import { ArrowUpRight, BookOpen, Check, Library } from 'lucide-react';
import { collections } from '../collections.js';

function categoryLabel(name) {
  const label = name.replace(/^Carte\s+/i, '').replace(/romaneasca/gi, 'românească').replace(/straina/gi, 'străină');
  const period = label.match(/\s+(\d{4}\s*[-–]\s*\d{4}|\d{4}\+)$/);
  return { title: period ? label.slice(0, period.index) : label, period: period?.[1].replace('-', '–') };
}

export default function CatalogCategories({ meta, filters, total, onCollection, onCategory }) {
  const categories = meta.categories.filter((item) => item.itemType === 'book');
  return <section id="catalog-collections" className="catalog-categories" aria-labelledby="catalog-categories-title">
    <header className="categories-heading">
      <div><h2 id="catalog-categories-title">Explorează colecțiile</h2></div>
      <button className={`catalog-all ${!filters.itemType && !filters.category ? 'active' : ''}`} aria-pressed={!filters.itemType && !filters.category} onClick={() => onCollection('')}><Library size={17}/><span>Întregul catalog</span><b>{total.toLocaleString('ro-RO')}</b></button>
    </header>
    <nav className="collection-nav" aria-label="Colecții digitale">
      {Object.entries(collections).map(([type, collection]) => {
        const Icon = collection.icon;
        const count = meta.collections.find((item) => item.type === type)?.count || 0;
        const selected = filters.itemType === type;
        return <button key={type} className={`collection-tile ${type} ${selected ? 'active' : ''}`} aria-pressed={selected} onClick={() => onCollection(selected && !filters.category ? '' : type)}>
          <span className={`collection-symbol ${type}`}><Icon size={24}/></span>
          <span className="collection-tile-copy"><strong>{collection.label}</strong><small>{count.toLocaleString('ro-RO')} {count === 1 ? 'document' : 'documente'}</small></span>
          <span className="collection-tile-indicator">{selected ? <Check size={17}/> : <ArrowUpRight size={17}/>}</span>
        </button>;
      })}
    </nav>
    {(!filters.itemType || filters.itemType === 'book') && categories.length > 0 && <div className="book-categories">
      <h3>Categorii de carte</h3>
      <nav className="category-tiles" aria-label="Categorii de carte">
        {categories.map((item) => {
          const { title, period } = categoryLabel(item.name);
          const selected = filters.itemType === 'book' && filters.category === item.name;
          return <button key={item.name} className={`category-tile ${selected ? 'selected' : ''}`} aria-pressed={selected} onClick={() => onCategory(selected ? '' : item.name)}>
            <span className="category-tile-icon">{selected ? <Check size={19}/> : <BookOpen size={19}/>}</span>
            <span className="category-tile-copy"><strong>{title}</strong>{period && <small>{period}</small>}</span>
            <span className="category-tile-count"><b>{item.count.toLocaleString('ro-RO')}</b><small>{item.count === 1 ? 'volum' : 'volume'}</small></span>
          </button>;
        })}
      </nav>
    </div>}
  </section>;
}
